/** Minutes between staggered copies. */
const STAGGER_STEP_MINUTES = 2

/**
 * Offset a daily cron by a few minutes per copy, carrying into the next
 * hour, so copying a schedule to a team does not manufacture a herd — N
 * profiles all hitting Apify at the same instant is exactly the load spike
 * the scheduler's rate-limit deferrals exist to survive, and there is no
 * reason to create it on purpose.
 *
 * Only the simple shape the schedule form composes ("0 M H * * *", numeric
 * minute and hour) is staggered; anything cleverer is copied verbatim
 * rather than risk changing what a hand-written expression means.
 *
 * The spread is per copy operation, not global: copying the same schedule to
 * a second team, or re-running after fixing the profiles that were skipped,
 * starts counting from one again and lands on the same minutes as the first
 * batch. That is a thinning of the herd rather than a guarantee against one
 * — the scheduler's rate-limit deferrals are what actually make a collision
 * safe.
 */
export function staggerCron(cron: string, index: number): string {
    const fields = cron.trim().split(/\s+/)
    if (fields.length !== 6) return cron
    const minute = Number(fields[1])
    const hour = Number(fields[2])
    if (!Number.isInteger(minute) || !Number.isInteger(hour)) return cron
    const total = hour * 60 + minute + index * STAGGER_STEP_MINUTES
    const nextHour = Math.floor(total / 60) % 24
    const nextMinute = total % 60
    return [fields[0], String(nextMinute), String(nextHour), ...fields.slice(3)].join(' ')
}
